module.exports = __webpack_public_path__ + "media/images/flags/1x1/mmr-8d155a89a492eb36d3f85eda10d72125.svg";